import { createContext, useContext, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { CreatePayment, GetOrderPaymentData, CollectElavonPaymentStatus, GetActivePaymentSuppliersForSites, ChangeTaskStatusIfNeeded } from '../Services/PaymentService';
import { useConfig } from './ConfigProvider';
import { useAuth } from './AuthProvider';
import { toast } from 'react-toastify';

const PaymentContext = createContext()
const EMPTY_ARRAY = []

export const usePayment = () => {
    return useContext(PaymentContext)
}

const PaymentProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const { data: allPaymentSuppliers } = useQuery({
        queryKey: ['payment', 'suppliers'],
        queryFn: async () => (await GetActivePaymentSuppliersForSites(api)).data,
        enabled: Boolean(api && authState.user),
        staleTime: 60 * 60 * 1000,
    })

    // Lista dostawców dla oddziału to wartość WYLICZANA z pobranych danych,
    // a nie osobny stan - useMemo zamiast useState + useEffect.
    const activePaymentSuppliersForSites = useMemo(() => {
        const effectiveSiteId = authState.selectedCustomerData?.siteId ?? authState.initialSiteId
        if (allPaymentSuppliers?.length > 0 && effectiveSiteId) {
            return allPaymentSuppliers.filter(supplier => supplier.siteId === effectiveSiteId)
        }
        return EMPTY_ARRAY
    }, [allPaymentSuppliers, authState.selectedCustomerData?.siteId, authState.initialSiteId])

    const paymentCreate = async (payment) => {
        try {
            const res = await CreatePayment(api, payment, 'Elavon')
            if (res) {
                return res.data;
            }
            else {
                toast.error('Błąd w trakcie generowania linku do płatności!')
                console.log("Nie ma odpowiedzi")
                return "";
            }
        } catch (e) {
            toast.error('Błąd w trakcie generowania linku do płatności!')
            console.error(e)
            return "";
        }
    }

    const handleGetPaymentData = async (paymentGuid) => {
        try {
            const result = await GetOrderPaymentData(api, paymentGuid)
            return result.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleCollectElavonPaymentStatus = async (paymentId) => {
        try {
            const res = await CollectElavonPaymentStatus(api, paymentId, authState.siteId)
            return res.data
        } catch (error) {
            console.log(error)
            return 99
        }
    }

    /**
     * DK : Funkcja zmienia status taska aby ponownie spróbował pobrac odpowiedz z bramki płatności, jeżeli status to 99
     * @param {*} remoteId Id zewnetrzne operatora płatności
     * @returns czy dokonano aktualizacji na wpisie
     */
    const handleChangeTaskStatusIfNeeded = async (remoteId) => {
        try {
            const res = await ChangeTaskStatusIfNeeded(api, remoteId)
            return res.data
        } catch (e) {
            console.log(e)
            return false
        }
    }

    return (
        <PaymentContext.Provider value={{
            paymentCreate,
            handleGetPaymentData,
            handleCollectElavonPaymentStatus,
            handleChangeTaskStatusIfNeeded,
            activePaymentSuppliersForSites,
        }}>
            {children}
        </PaymentContext.Provider>
    )
}

export default PaymentProvider
